import React from"react";

const supportedLanguages = [
 { code:"en", label:"English" },
 { code:"hi", label:"Hindi" },
 { code:"ta", label:"Tamil" },
 { code:"te", label:"Telugu" },
 { code:"kn", label:"Kannada" },
 { code:"mr", label:"Marathi" },
 { code:"gu", label:"Gujarati" },
 { code:"bn", label:"Bengali" },
 { code:"ml", label:"Malayalam" },
 { code:"pa", label:"Punjabi" },
];

const TSGLanguageSelector = ({ selectedLanguage, onChange }) => {
 return (
 <div className="flex items-center gap-2">
 <label
 htmlFor="lang-select"
 className="text-sm font-semibold text-primary"
 >
 </label>
 <select
 id="lang-select"
 value={selectedLanguage}
 onChange={(e) => onChange(e.target.value)}
 className="bg-[#1a1a1a] text-white border border-primary px-3 py-1.5 text-sm rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-500 transition-all duration-200"
 >
 {supportedLanguages.map((lang) => (
 <option key={lang.code} value={lang.code}>
 {lang.label}
 </option>
 ))}
 </select>
 </div>
 );
};

export default TSGLanguageSelector;



